import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useClockMetadataQuery = (clockId: string) => {
  return useQuery({
    queryKey: ["clockMetadata", clockId],
    queryFn: async () => {
      return adminApiClient.getClockMetadata(clockId);
    },
  });
};

export default useClockMetadataQuery;
